import { Grid, Paper, styled } from "@mui/material";
import { Outlet } from "react-router-dom";
import bgImage from "../assets/bg.svg";

interface Props {}

export const LoginLayout = (props: Props) => {
  return (
    <StyledGrid container>
      <Grid item xs={false} sm={4} md={7} className="cover" />
      <Grid
        item
        xs={12}
        sm={8}
        md={5}
        component={Paper}
        elevation={6}
        square
        className="login-panel"
      >
        <Outlet />
      </Grid>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  flex-grow: 1;

  .login-panel {
    display: flex;

    padding: ${({ theme }) => theme.spacing(12, 6)};
  }

  .cover {
    background-image: url(${bgImage});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
`;
